var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgGooglePlayIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "#fff",
  viewBox: "0 0 17.856 20.254"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M.571 20.254c-.347-.1-.573-.455-.573-1.008V.984A.98.98 0 0 1 .494.001l8.643 10.177Zm1.523-.416 10.4-6.122-2.534-2.984Zm10.258-13.8L2.095.001l7.668 9.086Zm.911.4 4.019 2.366a.86.86 0 0 1 0 1.622l-4.12 2.425-2.691-3.184Z",
  className: "google-play-icon_svg__a"
})));
export default SvgGooglePlayIcon;